import { notifications } from "@mantine/notifications";
import { useNavigate } from "@tanstack/react-router";
import { confirmSignIn } from "aws-amplify/auth";
import type { NewPasswordSettingForm } from "../../types/newPasswordSettingForm";

export const useConfirmSignIn = () => {
	const navigate = useNavigate();

	const handleSubmit = async (values: NewPasswordSettingForm) => {
		try {
			await confirmSignIn({
				challengeResponse: values.newPassword,
				options: {
					ChallengeName: "NEW_PASSWORD_REQUIRED",
				},
			});

			navigate({ to: "/" });
		} catch {
			// TODO: エラーハンドリング
			notifications.show({
				title: "パスワード再設定に失敗しました",
				message:
					"パスワード再設定に失敗しました。パスワードを確認して再度お試しください。",
				color: "red",
			});
		}
	};

	return { handleSubmit };
};
